// extracted by mini-css-extract-plugin
export default {"fieldset":"fieldset---nRgyJ","label":"label---OwgP7"};